/**
 * @fileoverview Toast object for notification
 */
'use strict';

/**
 * Constructor of toast
 * @constructor
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
Entry.Toast = /*#__PURE__*/function () {
  function Toast() {
    (0, _classCallCheck2["default"])(this, Toast);
    this.toasts_ = [];
    /** @type {Element} */
    var exist = document.getElementById('entryToastContainer');
    if (exist) {
      Entry.modalContainer.removeChild(exist);
    }
    this.body_ = Entry.createElement('div', 'entryToastContainer');
    this.body_.addClass('entryToastContainer');
    Entry.modalContainer.appendChild(this.body_);
  }
  return (0, _createClass2["default"])(Toast, [{
    key: "warning",
    value: function warning(title, message, isNotAutoDispose) {
      var toast = Entry.createElement('div', 'entryToast');
      toast.addClass('entryToast');
      toast.addClass('entryToastWarning');
      toast.bindOnClick(function () {
        Entry.toast.body_.removeChild(toast);
      });
      var toastTitle = Entry.createElement('div', 'entryToast');
      toastTitle.addClass('entryToastTitle');
      toastTitle.textContent = title;
      toast.appendChild(toastTitle);
      var toastMessage = Entry.createElement('p', 'entryToast');
      toastMessage.addClass('entryToastMessage');
      toastMessage.textContent = message;
      toast.appendChild(toastMessage);
      this.toasts_.push(toast);
      this.body_.appendChild(toast);
      var f = function f() {
        toast.style.opacity = 1;
        var timer = setInterval(function () {
          if (toast.style.opacity < 0.05) {
            clearInterval(timer);
            toast.style.display = 'none';
            Entry.removeElement(toast);
          }
          toast.style.opacity *= 0.9;
        }, 20);
      };
      if (!isNotAutoDispose) {
        window.setTimeout(f, 1000);
      }
    }
  }, {
    key: "success",
    value: function success(title, message, isNotAutoDispose) {
      var toast = Entry.createElement('div', 'entryToast');
      toast.addClass('entryToast');
      toast.addClass('entryToastSuccess');
      toast.bindOnClick(function () {
        Entry.toast.body_.removeChild(toast);
      });
      var toastTitle = Entry.createElement('div', 'entryToast');
      toastTitle.addClass('entryToastTitle');
      toastTitle.textContent = title;
      toast.appendChild(toastTitle);
      var toastMessage = Entry.createElement('p', 'entryToast');
      toastMessage.addClass('entryToastMessage');
      toastMessage.textContent = message;
      toast.appendChild(toastMessage);
      this.toasts_.push(toast);
      this.body_.appendChild(toast);
      var f = function f() {
        toast.style.opacity = 1;
        var timer = setInterval(function () {
          if (toast.style.opacity < 0.05) {
            clearInterval(timer);
            toast.style.display = 'none';
            Entry.removeElement(toast);
          }
          toast.style.opacity *= 0.9;
        }, 20);
      };
      if (!isNotAutoDispose) {
        window.setTimeout(f, 1000);
      }
    }
  }, {
    key: "alert",
    value: function alert(title, message, isNotAutoDispose) {
      var toast = Entry.createElement('div', 'entryToast');
      var timer;
      toast.addClass('entryToast');
      toast.addClass('entryToastAlert');
      toast.bindOnClick(function () {
        Entry.toast.body_.removeChild(toast);
        if (timer) {
          clearInterval(timer);
        }
      });
      var toastTitle = Entry.createElement('div', 'entryToast');
      toastTitle.addClass('entryToastTitle');
      toastTitle.textContent = title;
      toast.appendChild(toastTitle);
      var toastMessage = Entry.createElement('p', 'entryToast');
      toastMessage.addClass('entryToastMessage');
      if (Array.isArray(message)) {
        toastMessage.textContent = message.reduce(function (total, current) {
          return "".concat(total, "\n").concat(current);
        }, '');
      } else {
        toastMessage.textContent = message;
      }
      toast.appendChild(toastMessage);
      this.toasts_.push(toast);
      this.body_.appendChild(toast);
      var f = function f() {
        toast.style.opacity = 1;
        timer = setInterval(function () {
          if (toast.style.opacity < 0.05) {
            clearInterval(timer);
            toast.style.display = 'none';
            //check element already removed from parent
            if (toast.parentElement) {
              Entry.toast.body_.removeChild(toast);
            }
          }
          toast.style.opacity *= 0.9;
        }, 20);
      };
      if (!isNotAutoDispose) {
        window.setTimeout(f, 5000);
      }
      return toast;
    }
  }, {
    key: "isOpen",
    value: function isOpen(target) {
      var activated = this.toasts_.filter(function (toast) {
        return toast.style.display !== 'none';
      });
      if (target) {
        return activated.includes(target);
      }
      return activated.length > 0;
    }
  }]);
}();